// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bet_a big_rj big_rk big_vh big_eb big_vf big_gs big_kh"};